//Bootstrap JS
import * as bootstrap from 'bootstrap';

//glightbox
import GLightbox from 'glightbox';

import {initiateCookieConsent} from "./cookie-consent";

// swiper
import Swiper from 'swiper/swiper-bundle.min.js';

// GLightbox({
//     selector: '.glightbox'
// });

let swiper = new Swiper(".swiper-slider", {
    slidesPerView: "auto",
    navigation: {
      nextEl: ".carousel-control-next",
      prevEl: ".carousel-control-prev",
    },
  });

initiateCookieConsent();